import { h, provide, createApp } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import axios from 'axios';
import { Storage } from '../Consts/Storage';
import Alert from '@util/BrowserAlert';
// console.log('Storage REMOTE_BASE_URL', Storage.REMOTE_BASE_URL);
// console.log('Storage RECAPTCHA_SITE_KEY', Storage.RECAPTCHA_SITE_KEY);
// console.log('Storage KENALL_PUBLIC_KEY', Storage.KENALL_PUBLIC_KEY);
// console.log('Storage STRIPE_PUBLIC_KEY', Storage.STRIPE_PUBLIC_KEY);
// console.log('Storage STRIPE_SECRET_KEY', Storage.STRIPE_SECRET_KEY);
// Axiosの設定
axios.defaults.baseURL = Storage.REMOTE_BASE_URL;
axios.defaults.timeout = 30 * 1000;
axios.defaults.responseType = 'json';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
axios.interceptors.response.use(response => {
    return response;
}, error => {
    var _a;
    Alert.RequestError((_a = error.response) === null || _a === void 0 ? void 0 : _a.status);
    return error;
});
window.axios = axios;
createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        createApp({
            render: () => h(app, props),
            mounted: () => {
                // console.log('CreateApp mounted');
            },
            updated: () => {
                // console.log('CreateApp updated');
            },
            setup() {
                provide('remoteBaseUrl', Storage.REMOTE_BASE_URL);
                provide('recaptchaSiteKey', Storage.RECAPTCHA_SITE_KEY);
                // provide('kenallPublicKey', Storage.KENALL_PUBLIC_KEY);
                provide('stripePublicKey', Storage.STRIPE_PUBLIC_KEY);
                provide('stripeSecretKey', Storage.STRIPE_SECRET_KEY);
            },
        })
            .use(plugin)
            .mixin({
            methods: {
                route: (name, params, absolute, Ziggy) => route(name, params, absolute, Ziggy),
            },
        })
            .mount(el);
    },
});
